import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import { useCallback, useMemo } from 'react';
import { TimelineTooltipPayload } from '../lib/timeline-tooltip-types';
import { StationStatusFilterValue } from '../quality-result/filter-quality-stations-by-status';

/**
 * Centralizes PostHog events for the stream quality report. Semantic methods keep event names and
 * payload shapes in one place (same idea as useFragmentsViewCapture).
 */
export function useStreamQualityReportCapture() {
  const capture = usePostHogCapture({ domain: 'stream-quality' });

  const openLogger = useCallback(
    ({
      source,
      payload,
    }: {
      source: 'timeline' | 'issues_table';
      payload: TimelineTooltipPayload;
    }) => {
      capture('open_logger', {
        source,
        incident: payload,
      });
    },
    [capture],
  );

  const incidentsFilterChanged = useCallback(
    ({
      selected,
      selected_count,
    }: {
      selected: StationStatusFilterValue[];
      selected_count: number;
    }) => {
      capture('incidents_filter_changed', { selected, selected_count });
    },
    [capture],
  );

  return useMemo(
    () => ({
      openLogger,
      incidentsFilterChanged,
    }),
    [openLogger, incidentsFilterChanged],
  );
}
